import { MatPaginatorIntl } from '@angular/material/paginator';

export function getHungarianPaginatorIntl(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();
  intl.itemsPerPageLabel = 'Elem / oldal'; // vagy: 'Elemek száma oldalanként'
  intl.nextPageLabel = 'Következő oldal';
  intl.previousPageLabel = 'Előző oldal';
  intl.firstPageLabel = 'Első oldal';
  intl.lastPageLabel = 'Utolsó oldal';
  intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return '0 / ' + length;
    }
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} – ${endIndex} / ${length}`;
  };
  return intl;
}
